import { createStyles } from "@material-ui/core/styles";
import { BACKGROUND_COLOR, DARK_GREY, WHITE, ALMOST_WHITE, GRAY_SALT_SILVER, BLACK } from "constants/colors";

export const styles = () =>
  createStyles({
    root: {
      backgroundColor: BACKGROUND_COLOR,
      width: "100%",
      height: "200vh",
      padding: "0",
      margin: "0",
      "& .Mui-disabled": {
        color: "#757b86 !important",
      },
      "& .Mui-checked": {
        color: "#90caf9",
      },
    },
    logo: {
      width: "90%",
      maxWidth: "500px",
      paddingTop: "16px",
    },
    buttonLogin: {
      height: "auto",
      padding: "10px 16px",
      marginLeft: 8,
      backgroundColor: "#363d47",
      border: "none",
      borderRadius: "32px",
      cursor: "pointer",
      outline: "none",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      color: WHITE,
      fontWeight: "bold",
      "&:hover,&:focus": {
        color: BLACK,
        backgroundColor: "#90caf9",
        border: "none",
      },
      "& > span > span": {
        fontStyle: "normal",
        fontSize: 14,
        lineHeight: "19px",
        marginLeft: 5,
        fontWeight: 600,
      },
    },
    buttonLoginDisabled: {
      height: "auto",
      padding: "10px 16px",
      marginLeft: 8,
      backgroundColor: "#363d47",
      border: "none",
      borderRadius: "32px",
      cursor: "pointer",
      outline: "none",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      color: WHITE,
      fontWeight: "bold",
      opacity: 0.5,
      "& > span > span": {
        color: WHITE,
        fontStyle: "normal",
        fontSize: 14,
        lineHeight: "19px",
        marginLeft: 9,
        fontWeight: 600,
      },
      "& > span > img": {
        color: WHITE,
      },
    },
    cardConetent: {
      backgroundColor: BACKGROUND_COLOR,
      paddingRight: 32,
    },
    loginTextMessage: {
      fontFamily: "Roboto",
      fontSize: "14px",
      fontWeight: "normal",
      fontStretch: "normal",
      paddingTop: "20px",
      fontStyle: "normal",
      width: "150px",
      lineHeight: "1.43",
      paddingLeft: "0px !important",
      letterSpacing: "normal",
      color: ALMOST_WHITE,
      margin: "0px",
    },
    appVersion: {
      padding: "32px 0px",
    },
    line: {
      padding: 0,
      margin: "0px 8px 32px 0px",
      border: `1px solid ${GRAY_SALT_SILVER}`,
    },
    cardContenteLegends: {
      padding: 0,
      paddingLeft: 16,
    },
    legends: {
      fontFamily: "Roboto",
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 14,
      color: ALMOST_WHITE,
      "& > span": {
        display: "block",
        marginTop: "4px",
      },
    },
    containerLegends: {
      marginTop: 32,
    },
    contact: {
      color: WHITE,
    },

    checkBoxLabel: {
      color: WHITE,
    },

    checkbox: {
      color: "white",
    },
    forwardIcon: {
      fontSize: "1.0rem !important",
    },
  });
